import {
    DocumentPreviewProvider,
    DocumentSignModalProvider,
    DossierDocumentSignProvider,
    DossierPrescriberProvider,
    TypeDocumentsProvider,
    DocumentSignModalWrapper,
    CollectionBillingProvider,
} from '@europrocurement/l2d-modules';
import React from 'react';
import DetailDossierContainer from '../../components/DetailDossierContainer/DetailDossierContainer';

// Some providers are defined in the GlobalDataProvider (B2DLayout)
// ex: currentDossierProvider, UsersProvider; validators...
const DetailDossier: React.FunctionComponent = function () {
    return (
        <DocumentSignModalProvider>
            <DossierDocumentSignProvider>
                <TypeDocumentsProvider autoload>
                    <CollectionBillingProvider autoload={false}>
                        <DocumentPreviewProvider>
                            <DossierPrescriberProvider>
                                <DetailDossierContainer />
                            </DossierPrescriberProvider>
                            <DocumentSignModalWrapper />
                        </DocumentPreviewProvider>
                    </CollectionBillingProvider>
                </TypeDocumentsProvider>
            </DossierDocumentSignProvider>
        </DocumentSignModalProvider>
    );
};

export default DetailDossier;
